export const dom = {};

export function initDom() {
    dom.radarContainer = document.getElementById('radar-container');
    dom.canvas = document.getElementById('radar-canvas');
    dom.ctx = dom.canvas.getContext('2d');
    dom.scoreLabel = document.getElementById('score-label');
    dom.totalScoreEl = document.getElementById('total-score');
    dom.levelButtonsContainer = document.getElementById('level-buttons');
    dom.levelButtons = [];
    dom.dailyChallengeBtn = document.getElementById('daily-challenge-btn');
    dom.timeChallengeBtn = document.getElementById('time-challenge-btn');
    dom.timeStatus = document.getElementById('time-status');
    dom.timeTimer = document.getElementById('time-timer');
    dom.timerProgress = document.getElementById('timer-progress');
    dom.timerProgressFill = document.getElementById('timer-progress-fill');
    dom.slider = document.getElementById('distance-slider');
    dom.sliderValueDisplay = document.getElementById('slider-value-display');
    dom.sliderLabelLeft = document.getElementById('slider-label-left');
    dom.sliderLabelRight = document.getElementById('slider-label-right');
    dom.sliderSubLabelLeft = document.getElementById('slider-sublabel-left');
    dom.sliderSubLabelRight = document.getElementById('slider-sublabel-right');
    dom.submitBtn = document.getElementById('submit-btn');
    dom.exitDailyBtn = document.getElementById('exit-daily-btn');
    dom.replayLevelBtn = document.getElementById('replay-level-btn');
    dom.resultTextEl = document.getElementById('result-text');
    dom.playerGuessMarker = document.getElementById('player-guess-marker');
    dom.correctAnswerMarker = document.getElementById('correct-answer-marker');
    dom.bracketPerfectL = document.getElementById('bracket-perfect-left');
    dom.bracketPerfectR = document.getElementById('bracket-perfect-right');
    dom.bracketMaxL = document.getElementById('bracket-max-left');
    dom.bracketMaxR = document.getElementById('bracket-max-right');
    dom.summaryModal = document.getElementById('summary-modal');
    dom.finalScoreEl = document.getElementById('final-score');
    dom.scoreBreakdownListEl = document.getElementById('score-breakdown-list');
    dom.resetGameBtn = document.getElementById('reset-game-btn');
    dom.explanationContainer = document.getElementById('explanation-container');
    dom.gameShell = document.querySelector('.game-shell');
    dom.dailyNameModal = document.getElementById('daily-name-modal');
    dom.dailyNameForm = document.getElementById('daily-name-form');
    dom.dailyNameInput = document.getElementById('daily-player-name');
    dom.dailyNameCancelBtn = document.getElementById('daily-name-cancel-btn');
    dom.dailyLeaderboardModal = document.getElementById('daily-leaderboard-modal');
    dom.dailyLeaderboardDate = document.getElementById('daily-leaderboard-date');
    dom.dailySubmitStatus = document.getElementById('daily-submit-status');
    dom.dailyLeaderboardList = document.getElementById('daily-leaderboard-list');
    dom.dailyLeaderboardCloseBtn = document.getElementById('daily-leaderboard-close-btn');
    dom.dailyLeaderboardPlayBtn = document.getElementById('daily-leaderboard-play-btn');
    dom.timeNameModal = document.getElementById('time-name-modal');
    dom.timeNameForm = document.getElementById('time-name-form');
    dom.timeNameInput = document.getElementById('time-player-name');
    dom.timeNameCancelBtn = document.getElementById('time-name-cancel-btn');
    dom.timeLeaderboardModal = document.getElementById('time-leaderboard-modal');
    dom.timeLeaderboardDate = document.getElementById('time-leaderboard-date');
    dom.timeSubmitStatus = document.getElementById('time-submit-status');
    dom.timeLeaderboardList = document.getElementById('time-leaderboard-list');
    dom.timeLeaderboardCloseBtn = document.getElementById('time-leaderboard-close-btn');
    dom.timeLeaderboardPlayBtn = document.getElementById('time-leaderboard-play-btn');
    dom.timeDailyTab = document.getElementById('time-daily-tab');
    dom.timeAllTimeTab = document.getElementById('time-all-time-tab');
}

export const scoreBrackets = () => [
    dom.bracketPerfectL,
    dom.bracketPerfectR,
    dom.bracketMaxL,
    dom.bracketMaxR,
];
